import React, { useState } from 'react';
import { debugTheme } from './debugTheme';

interface WiringSectionProps {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  theme?: 'dark' | 'light';
  children: React.ReactNode;
}

const themes = {
  dark: {
    header: `${debugTheme.dark.bgAlt} hover:bg-nightshade-700 ${debugTheme.dark.text}`,
    badge: debugTheme.dark.badge,
    content: debugTheme.dark.bg,
    chevron: debugTheme.dark.chevron,
  },
  light: {
    header: `${debugTheme.light.bgAlt} hover:bg-slate-100 ${debugTheme.light.text}`,
    badge: debugTheme.light.badge,
    content: debugTheme.light.bg,
    chevron: debugTheme.light.chevron,
  },
};

export function WiringSection({
  title,
  count,
  defaultOpen = false,
  theme = 'dark',
  children,
}: WiringSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const t = themes[theme];

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`w-full flex items-center gap-1.5 px-2 py-1.5 font-mono text-[11px] cursor-pointer select-none ${t.header}`}
      >
        <span
          className={`inline-block transition-transform duration-150 ${t.chevron} ${open ? 'rotate-90' : ''}`}
        >
          ▶
        </span>
        <span>{title}</span>
        {count != null && (
          <span className={`ml-auto text-[10px] px-1.5 py-0.5 rounded-full ${t.badge}`}>
            {count}
          </span>
        )}
      </button>
      {open && <div className={`px-2 py-1.5 ${t.content}`}>{children}</div>}
    </div>
  );
}
